<template>
<v-container>
    <v-img
        :src="require('../assets/mona_logo.png')"
        class="my-3"
        contain
        width="40px"
    />
</v-container>
</template>

<script>
export default {
    name: 'Logo',
    props: ['width', 'height'],
}
</script>